import type {SxProp} from '@primer/styled-react'
import {Box} from '@primer/styled-react'
import {clsx} from 'clsx'
import type React from 'react'

import styles from './Section.module.css'

export type SectionProps = {
  children?: React.ReactNode
  emptyText?: string | React.ReactElement
  sectionHeader: React.ReactElement
  sectionFooter?: React.ReactElement
  hideDivider?: boolean
  id?: string
  className?: string
} & SxProp

export function Section({
  children,
  emptyText,
  sectionHeader,
  sectionFooter,
  hideDivider,
  id,
  sx,
  className,
}: SectionProps) {
  return (
    <Box
      data-testid={id ?? 'sidebar-section'}
      sx={{
        marginBottom: hideDivider ? 0 : 2,

        ':after': hideDivider
          ? undefined
          : {
              content: '""',
              position: 'absolute',
              height: '1px',
              bottom: '-8px',
              left: '8px',
              right: '8px',
              bg: 'border.muted',
            },

        ...sx,
      }}
      className={clsx(styles.SectionContainer, className)}
    >
      <div className={styles.headerContentWrapper}>
        {sectionHeader}
        {emptyText && (
          <>
            <span className={styles.emptyText}>{emptyText}</span>
            <div className={styles.hiddenChildrenContainer}>{children}</div>
          </>
        )}
      </div>
      {!emptyText && <div className={styles.childrenContainer}>{children}</div>}
      {sectionFooter}
    </Box>
  )
}

try{ Section.displayName ||= 'Section' } catch {}